import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1alzanul2v: FaireBrandEntity = {
  token: "b_1alzanul2v",
  type: "brand",
  name: "Wildland Organics",
  avatarUrl:
    "https://cdn.faire.com/fastly/14e9ff4fd95eabf862b4f15afb92de9edbc6b61b17b056f8a0177eb31a1ce494.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/6b5c400b2e7e31f7f8d60827a2105ada78c48ddeff00138fb7105248f72671b3.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/14e9ff4fd95eabf862b4f15afb92de9edbc6b61b17b056f8a0177eb31a1ce494.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6b5c400b2e7e31f7f8d60827a2105ada78c48ddeff00138fb7105248f72671b3.jpeg",
  location: "Idyllwild, CA, USA",
  minimumOrderDollars: 50,
  rating: 5,
  reviewCount: 27,
  isTopShop: true,
  isInsider: true,
  description:
    "Co-founded by husband/wife team Marisa and Daane Griffeth, Wildland believes in a life unburdened by excess and elevated by positive energy. A mindful life spent connecting with nature, creating space for possibility, and breathing life into our wild roots.\n\nInspired by the multi-faceted healing power of nature, Wildland is redefining the paradigm of multi-use by creating highly adaptable and effective formulas for mind and body. A high-vibe solution for those seeking to live light and live luxuriously.\n\nWildland is committed to using all-natural, organic, cruelty-free, and sustainably wildcrafted ingredients. We are 100% transparent with our ingredient decks, and are here to answer any questions you may have. We are proud to have been featured in gold-standard media outlets like Refinery 29, People Magazine, The LA Times, and Coveteur among others. \n\nIn addition to using only the finest plant-based ingredients, Sustainable Packaging and practices are at the heart of everything we do - we invite you to read more about our Eco-Commitment here: https://www.wildlandorganics.com/pages/wildland-eco-commitment\n\nWildland Organics is proudly nestled in the San Jacinto Mountains of Idyllwild, California. We invite you to visit our brick & mortar retail shop at 54425 N. Circle Dr, Idyllwild CA 92549\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:43:55.816Z",
    importedBy: "entity-db-cli",
  },
};
